const es = {
  common: {
    actions: {
      close: 'Cerrar',
      accept: 'Aceptar',
      back: 'Atrás',
      continue: 'Continuar',
    },
    errors: {
      title: 'Error',
      unknown: 'Error desconocido.',
    },
    fields: {
      email: 'Correo electrónico',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      country: 'País',
      city: 'Ciudad',
      postalCode: 'Código postal',
      password: 'Contraseña',
      confirmPassword: 'Repite la contraseña',
      companyName: 'Nombre de la empresa',
      userType: 'Tipo de usuario',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
    },
    userTypes: {
      person: 'Autónomo',
      company: 'Empresa',
      agent: 'Gestor',
    },
  },

  paymentCancelled: {
    title: 'Pago cancelado',
    description:
      'El proceso de pago se ha cancelado. Si ha sido un error, puedes volver a intentarlo.',
  },

  paymentSuccess: {
    title: '¡Pago realizado con éxito!',
    descriptionDemo:
      'Ya puedes <link>acceder</link> y disfrutar de todas las ventajas de nuestra plataforma.',
    descriptionStandard:
      'Hemos enviado un correo electrónico con los detalles de tu suscripción. Por favor, revisa tu bandeja de entrada y sigue las instrucciones para completar el proceso.',
  },

  registration: {
    title: 'Comenzar registro',
    titleDemo: 'Comenzar registro en demo',
    complete: 'Completa',
    stepsCount: '3 pasos',
    toCreateAccount: 'para crear tu cuenta',
    planFallback: 'Plan',
    planSelection: 'Selección de plan',
    expensesTotalUsers: 'Total: {{total}} usuarios en Billivo Expenses ({{base}} incluidos en el plan)',
    inviteApplied:
      'Invitación de tu gestoría aplicada: 50 € de descuento en el plan anual Business Advance + Acceso al Contable.',
    inviteRequiresPlan:
      'Tu gestoría te invita con 50 € de descuento. El descuento se aplica al plan Business Advance + Acceso al Contable con facturación anual.',

    steps: {
      account: 'Cuenta',
      userData: 'Datos del usuario',
      addressAndConfirmation: 'Dirección y confirmación',
      planAndAccount: 'Plan y cuenta',
    },

    userTypes: {
      person: 'Autónomo',
      company: 'Compañía',
      agent: 'Gestor',
    },

    fields: {
      agentName: 'Nombre del gestor',
      agentDocument: 'NIF/CIF/NIE',
      agentVatId: 'VAT ID',
      agentPhoneNumber: 'Número de teléfono',
      agentWebsite: 'Web',
      referralOptIn: '¿Quieres participar en el sistema de referidos de gestor?',
      subscriptionPlan: 'Plan de suscripción',
      billingPeriod: 'Período de facturación',
      expensesPacks: 'Packs extra de Billivo Expenses (10 usuarios cada uno)',
      userType: 'Tipo de usuario',
      companyName: 'Nombre de la empresa',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Repite la contraseña',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      vatId: 'VAT ID',
      phoneNumber: 'Número de teléfono',
      taxType: 'Tipo de impuesto',
      addressLine1: 'Línea de dirección 1',
      addressLine2: 'Línea de dirección 2',
      postalCode: 'Código postal',
      city: 'Ciudad',
      country: 'País',
      discountCode: 'Código de descuento',
      referredByCode: 'Código de referencia',
    },

    billing: {
      monthly: 'Mensual',
      yearly: 'Anual',
      popular: 'Popular',
      save17: 'Ahorra 17%',
      monthShort: 'mes',
      yearShort: 'año',
    },

    taxTypes: {
      peninsula: '01 - Península',
      ceutaMelilla: '02 - Ceuta y Melilla',
      canaryIslands: '03 - Islas Canarias',
      other: '05 - Otros',
    },

    api: {
      devOnly: '⚙️ [SOLO PARA DESARROLLADORES]',
      useApi: 'Quiero utilizar la API de Billivo',
      numberingManagement: 'Gestión de numeración',
      selectOption: 'Selecciona una opción',
      erpOption: 'Quiero controlar yo mismo la numeración de facturas',
      noErpOption: 'Deseo que Billivo gestione la numeración',
    },

    accessibility: {
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      showConfirmPassword: 'Mostrar confirmación',
      hideConfirmPassword: 'Ocultar confirmación',
    },

    actions: {
      continue: 'Continuar',
      back: 'Atrás',
      sending: 'Enviando...',
      finishRegistration: 'Finalizar registro',
      close: 'Cerrar',
      accept: 'Aceptar',
    },

    status: {
      sendingInfo: 'Enviando información...',
    },

    errors: {
      title: 'Error',
      unknown: 'Error desconocido.',
      submitUnknown: 'Error desconocido al enviar el formulario',
      stripeLoadFailed: 'No se pudo cargar Stripe.',
      noSession: 'No hay ninguna sesión a la que redirigir',
    },

    validation: {
      invalidWebsite: 'La web no es válida',
      validOption: 'Selecciona una opción válida',
      apiUsageTypeRequired: 'Selecciona cómo gestionar la numeración',
      emailRequired: 'El correo electrónico es obligatorio',
      invalidEmail: 'Correo electrónico no válido',
      companyNameRequired: 'El nombre de la compañía es obligatorio',
      firstNameRequired: 'El nombre es obligatorio',
      lastNameRequired: 'Los apellidos son obligatorios',
      nationalIdRequired: 'NIF/NIE/CIF es obligatorio',
      invalidDocument: 'Documento no válido',
      invalidCif: 'CIF no válido',
      invalidNifNie: 'NIF/NIE no válido',
      taxTypeRequired: 'El tipo de impuesto es obligatorio',
      phoneRequired: 'El número de teléfono es obligatorio',
      addressRequired: 'La dirección es obligatoria',
      postalCodeRequired: 'El código postal es obligatorio',
      cityRequired: 'La ciudad es obligatoria',
      countryRequired: 'El país es obligatorio',
      billingPeriodRequired: 'El período de facturación es obligatorio',
      passwordRequired: 'La contraseña es obligatoria',
      passwordMin: 'Mínimo 8 caracteres',
      confirmPasswordRequired: 'Repite la contraseña',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      maxLength: 'Máximo {{max}} caracteres',
      maxValue: 'Máximo {{max}}',
    },

    terms: {
      acceptPrefix: 'Acepto los',
      linkText: 'términos y condiciones',
      title: 'Términos y Condiciones',
      sections: {
        general: {
          title: '1. Información general y aceptación',
          body: 'Estos términos y condiciones regulan el acceso y uso de Billivo.',
        },
        definitions: {
          title: '2. Definiciones',
          body: 'Usuario: persona física que utiliza Billivo. Servicios: funcionalidades ofrecidas a través de Billivo. Contenido: cualquier información o material disponible en Billivo.',
        },
        scope: {
          title: '3. Objeto y alcance',
          body: 'Billivo permite a los usuarios acceder a los servicios ofrecidos por la empresa.',
        },
        access: {
          title: '4. Alta y acceso',
          body: 'Puede ser necesario registrarse y crear una cuenta con datos veraces y actualizados.',
        },
        usage: {
          title: '5. Uso de Billivo',
          body: 'El usuario se compromete a utilizar Billivo de forma lícita y de buena fe.',
        },
        privacy: {
          title: '6. Privacidad y protección de datos',
          body: 'La recogida y el tratamiento de datos personales se rigen por la normativa vigente.',
        },
        communications: {
          title: '7. Comunicaciones comerciales y boletines',
          body: 'Al aceptar estos términos, el usuario autoriza determinadas comunicaciones relacionadas con Billivo.',
        },
        intellectualProperty: {
          title: '8. Propiedad intelectual e industrial',
          body: 'Todos los derechos sobre Billivo y sus contenidos pertenecen a la empresa o a terceros autorizados.',
        },
        liability: {
          title: '9. Exclusión de garantías y responsabilidad',
          body: 'La empresa no garantiza la disponibilidad continua de Billivo en todos los casos.',
        },
        thirdPartyLinks: {
          title: '10. Enlaces a sitios de terceros',
          body: 'Billivo puede incluir enlaces a sitios de terceros, sin responsabilizarse de su contenido.',
        },
        modifications: {
          title: '11. Modificación de los Términos',
          body: 'La empresa podrá modificar estos términos cuando lo considere necesario.',
        },
        termination: {
          title: '12. Terminación',
          body: 'La empresa podrá suspender o cancelar el acceso en caso de incumplimiento o uso fraudulento.',
        },
        jurisdiction: {
          title: '13. Ley aplicable y jurisdicción',
          body: 'Estos términos se rigen por la legislación española.',
        },
        contact: {
          title: '14. Contacto',
          body: 'Para cualquier duda, el usuario puede contactar con la empresa por correo electrónico.',
        },
      },
    },
  },

  registrationSuccess: {
    title: '¡Registro realizado con éxito!',
    descriptionDemo:
      'Ya puedes <link>acceder</link> y disfrutar de todas las ventajas de nuestra plataforma.',
    descriptionStandard:
      'Hemos enviado un correo electrónico con los detalles de tu registro. Por favor, revisa tu bandeja de entrada y sigue las instrucciones para completar el proceso.',

    apiCredentials: {
      title: 'Credenciales de API - ¡IMPORTANTE!',
      warning:
        'Esta contraseña <strong>NO se ha guardado</strong> y solo se mostrará una vez. Guárdala en un lugar seguro antes de salir de esta página.',
      emailLabel: 'Correo electrónico:',
      passwordLabel: 'Contraseña:',
    },

    snackbar: {
      copied: '{{field}} copiado al portapapeles',
      email: 'Correo electrónico',
      password: 'Contraseña',
    },
  },

  simpleForm: {
    title: 'Registro rápido',
    subtitle: 'Completa el formulario y al finalizar te mostraremos tu QR.',
    optional: 'Opcional',
    fields: {
      country: 'País',
      userType: 'Tipo de usuario',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      companyName: 'Nombre de la empresa',
      email: 'Correo electrónico',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      taxId: 'Número de identificación fiscal',
      taxIdOptional: 'Número de identificación fiscal (opcional)',
    },
    userTypes: {
      person: 'Autónomo',
      company: 'Empresa',
    },
    helpers: {
      companyCif: 'Introduce el CIF de la empresa',
      personNifNie: 'Introduce tu NIF o NIE',
      euRequired: 'Este campo es obligatorio para clientes de la UE',
      outsideEuOptional: 'Puedes completarlo si dispones de identificación fiscal',
    },
    validation: {
      countryRequired: 'El país es obligatorio',
      userTypeRequired: 'El tipo de usuario es obligatorio',
      emailRequired: 'El correo electrónico es obligatorio',
      invalidEmail: 'Correo electrónico no válido',
      companyNameRequired: 'El nombre de la compañía es obligatorio',
      firstNameRequired: 'El nombre es obligatorio',
      lastNameRequired: 'Los apellidos son obligatorios',
      nationalIdRequiredSpain: 'NIF/NIE/CIF es obligatorio',
      invalidDocument: 'Documento no válido',
      invalidCif: 'CIF no válido',
      invalidNifNie: 'NIF/NIE no válido',
      taxIdRequired: 'El número de identificación fiscal es obligatorio',
    },
    actions: {
      register: 'Registrarme',
      registering: 'Registrando...',
      close: 'Cerrar',
      accept: 'Aceptar',
    },
    status: {
      sending: 'Enviando información...',
    },
    errors: {
      title: 'Error',
      unknownError: 'Error desconocido.',
      submitError: 'Error desconocido al enviar el formulario',
    },
    terms: {
      acceptPrefix: 'Acepto los',
      linkText: 'términos y condiciones',
      title: 'Términos y Condiciones',
      sections: {
        general: {
          title: '1. Información general y aceptación',
          body: 'Estos términos y condiciones (los "Términos") regulan el acceso y uso de la aplicación móvil y/o web (en adelante Billivo) desarrollada por Code10 IT Consultants S.L. Si no estás de acuerdo con los Términos, no utilices Billivo.',
        },
        definitions: {
          title: '2. Definiciones',
          body: 'Usuario: la persona física que, una vez aceptados estos Términos, utiliza Billivo independientemente de si actúa en nombre propio o en representación de un tercero.',
        },
        scope: {
          title: '3. Objeto y alcance',
          body: 'Billivo permite a los Usuarios acceder a los Servicios ofrecidos por la empresa. El uso de Billivo tiene carácter personal y no comercial.',
        },
        access: {
          title: '4. Alta y acceso',
          body: 'Para utilizar determinados Servicios puede ser necesario registrarse y crear una cuenta, facilitando datos veraces y actualizados. El Usuario es responsable de custodiar sus credenciales.',
        },
        usage: {
          title: '5. Uso de Billivo',
          body: 'El Usuario se compromete a utilizar Billivo de manera lícita, de buena fe y sin contravenir el ordenamiento jurídico.',
        },
        privacy: {
          title: '6. Privacidad y protección de datos',
          body: 'La recogida y el tratamiento de datos personales se rigen por la Política de Privacidad y la normativa vigente aplicable.',
        },
        communications: {
          title: '7. Comunicaciones comerciales y boletines',
          body: 'Al aceptar estos Términos y darse de alta en Billivo, el Usuario autoriza expresamente a la empresa a utilizar su dirección de correo electrónico y otros datos de contacto para enviarle comunicaciones.',
        },
        intellectualProperty: {
          title: '8. Propiedad intelectual e industrial',
          body: 'Todos los derechos de propiedad intelectual e industrial sobre Billivo, sus códigos fuente, diseño, contenidos, logotipos y marcas pertenecen a la empresa o a terceros que han autorizado su uso.',
        },
        liability: {
          title: '9. Exclusión de garantías y responsabilidad',
          body: 'La empresa no garantiza la disponibilidad, continuidad ni infalibilidad de Billivo y queda exenta de responsabilidad en la medida permitida por la ley.',
        },
        thirdPartyLinks: {
          title: '10. Enlaces a sitios de terceros',
          body: 'Billivo puede incluir enlaces a sitios web o contenidos de terceros. La empresa no controla estos sitios y no es responsable de su contenido.',
        },
        modifications: {
          title: '11. Modificación de los Términos',
          body: 'La empresa podrá modificar estos Términos cuando lo considere necesario. Las modificaciones entrarán en vigor desde su publicación.',
        },
        termination: {
          title: '12. Terminación',
          body: 'La empresa podrá suspender o cancelar el acceso del Usuario cuando detecte incumplimientos, uso fraudulento o contrario a la ley.',
        },
        jurisdiction: {
          title: '13. Ley aplicable y jurisdicción',
          body: 'Estos Términos se rigen por la legislación española. Para la resolución de conflictos, las partes se someten a los juzgados y tribunales competentes.',
        },
        contact: {
          title: '14. Contacto',
          body: 'Para cualquier duda o consulta, el Usuario puede ponerse en contacto con la empresa enviando un correo electrónico a support@billivo.com.',
        },
      },
    },
  },

  simpleFormSuccess: {
    notFound: {
      title: 'No se ha encontrado el registro',
      description: 'No tenemos información suficiente para mostrar el QR.',
      backButton: 'Volver al formulario',
    },
    success: {
      title: '¡Registro realizado con éxito!',
      description:
        'Tu usuario se ha creado correctamente. Guarda este QR y muéstraselo al conductor para que pueda emitir tu factura.',
    },
    temporaryPassword: {
      title: 'Contraseña temporal',
      description:
        'Esta contraseña se ha generado automáticamente y deberá cambiarse en el primer acceso.',
      emailLabel: 'Correo electrónico:',
      passwordLabel: 'Contraseña temporal:',
    },
    snackbar: {
      copied: '{{field}} copiado al portapapeles',
      email: 'Correo electrónico',
      temporaryPassword: 'Contraseña temporal',
    },
  },
};

export default es;
